import { jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
/* empty css              */
const Directive = (t0) => {
  const $ = c(2);
  const {
    directive
  } = t0;
  let t1;
  if ($[0] !== directive.name.value) {
    t1 = /* @__PURE__ */ jsxs("span", { className: "graphiql-doc-explorer-directive", children: [
      "@",
      directive.name.value
    ] });
    $[0] = directive.name.value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export {
  Directive
};
//# sourceMappingURL=directive.js.map
